import { Box, Container } from "@mui/material";
import { useArrangement } from "../../context/ArrangementProvider";
import MonetaryText from "../MonetaryText";


/**
 * Amount input
 * @returns
 */
export default function AmountInput() {

  const { plan } = useArrangement();

  return plan && (
    <Container sx={{
      display: "flex",
      textAlign: "center",
      justifyContent: "center",
      padding: 2
    }}>
      <Box
        id="payment-plan-amount"
        name="amount"
        sx={{
          width: "200px",
          height: "60px",
          backgroundColor: "primary.contrastText",
          color: "black",
          fontSize: 36,
          fontWeight: "bold"
        }}
      >
        <MonetaryText value={plan?.instalmentAmount.toFixed(2)} />
      </Box>
    </Container>
  );
}
